import { SNAPASK_SITE_ENDPOINT } from 'config';
import { isObjectEmpty } from './common';

export const createBreadcrumbForJsonLD = (breadcrumbList, name) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    name,
    itemListElement: breadcrumbList.map(({ label, link }, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: label,
      item: {
        '@id': `${SNAPASK_SITE_ENDPOINT}${link}`,
        name: label,
      },
    })),
  };
};

const getCheckoutCollectionListFromContentList = contentList => {
  if (!contentList || contentList.length === 0) return [];

  return Object.entries(contentList)
    .map(([, contentInfo]) => {
      return Object.entries(contentInfo)
        .map(([, checkoutCollection]) => {
          if (Array.isArray(checkoutCollection))
            return checkoutCollection.flat();

          return [checkoutCollection];
        })
        .flat();
    })
    .flat();
};

const getCheckoutCollectionListFromPaymentOptionList = (main, contentList) => {
  const contentCheckoutCollectionList = getCheckoutCollectionListFromContentList(
    contentList,
  );

  if (isObjectEmpty(main)) return contentCheckoutCollectionList;

  return [main, ...contentCheckoutCollectionList];
};

export const getOfferInfoForJsonLD = (main, contentList) => {
  const checkoutCollectionList = getCheckoutCollectionListFromPaymentOptionList(
    main,
    contentList,
  );

  if (checkoutCollectionList.length === 0) return {};

  const sortList = [...checkoutCollectionList]
    .filter(item => !isObjectEmpty(item) && !!item.price)
    .sort((a, b) => {
      return (+a.price?.sellingPrice || 0) - (+b.price?.sellingPrice || 0);
    });

  const low = sortList[0];
  const high = sortList[sortList.length - 1];

  return {
    offers: {
      '@type': 'AggregateOffer',
      lowPrice: +low.price?.sellingPrice || 0,
      highPrice: +high.price?.sellingPrice || 0,
      priceCurrency: high.plan.currency,
    },
  };
};

export const getRatingForJsonLD = (ratingValue, ratingList) => {
  if (!ratingList || ratingList.length === 0) return {};

  const sortRatingList = [...ratingList].sort((a, b) => a.stars - b.stars);

  const ratingCount = ratingList.length;

  return {
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue,
      ratingCount,
      bestRating: sortRatingList[ratingCount - 1].stars,
      worstRating: sortRatingList[0].stars,
    },
  };
};
